module.exports = __webpack_public_path__ + "f7155367498db4e86049d705e91b8956.svg";